<script>
import { mapGetters } from 'vuex';
import bem from '@/utils/bem';
import SubNavigation from '@/components/ux/subNavigation/SubNavigation.vue';
import companyTabMixin from '@/mixins/companyTabMixin';

const b = bem('company-tab-layout');

export default {
  components: {
    SubNavigation,
  },
  mixins: [companyTabMixin],
  props: {
    activeTab: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      isCompanyUser: 'auth/isCompanyUser',
    }),
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
  },
};
</script>

<template>
  <div :class="b()">
    <a-spin :spinning="!isCurrentCompanyLoaded">
      <!-- Company users navigate via sidebar — hide SubNavigation to avoid duplication -->
      <SubNavigation v-if="!isCompanyUser" :company-id="companyId" :active-tab="activeTab" />

      <div :class="b('content')">
        <slot :company-id="companyId" />
      </div>
    </a-spin>
  </div>
</template>

<style scoped lang="scss">
.company-tab-layout {
  &__content {
    padding: 20px;
    background: #fff;
    border-radius: 4px;
    margin: 0 20px;
  }
}
</style>
